'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _d3Color = require('d3-color');

var darken = function darken(k) {
  return function (specifier) {
    return (0, _d3Color.color)(specifier).darker(k).toString();
  };
};
var darken1 = darken(0.18);
var darken2 = darken(0.32);
var darken3 = darken(0.6);

exports.default = {
  darken: darken,
  darken1: darken1,
  darken2: darken2,
  darken3: darken3
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../mcs-lite-theme/lib/darken.js
// module id = 342
// module chunks = 4